// module packer
import Modules from '@/core/site-map/map.json'
// import notFound from '@/components/GeneralViews/NotFound.vue'

export const include = (pack) => {
  const bundle = {}
  const modules = Modules[pack].pack

  Object.keys(modules).forEach(key => {
    const module = modules[key]
    bundle[module] = () => import(
      /* webpackChunkName: "base" */
      /* webpackMode: "lazy-once" */
      `@/components/_modules/${pack}/${module}/index.vue`
    )
    bundle[module + '/create'] = () => import(
      /* webpackChunkName: "base" */
      /* webpackMode: "lazy-once" */
      `@/components/_modules/${pack}/${module}/create.vue`
    ).catch((e) => {
      console.warn('Not found')
      global.app.$router.push(global.app.$routerHistory.previous().path)
      global.app.$loading = false
      throw new Error('page not found')
    }).catch((e) => {
      //
      if (!global.pageNotFound) {
        global.pageNotFound = true
        global.app.$notifications.notify({
          type: 'plain',
          icon: 'exclamation-circle',
          message: global.app.$i18n.t('pageNotSupported'),
          placement: { from: 'top', align: 'center' }
        })
      }
    })
  })

  return bundle
}



// WEBPACK FOOTER //
// ./src/core/utils/bundler.js